module.exports = __webpack_public_path__ + "static/media/home-slide-2.c6fd12aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/MainImage/home-slide-2.jpg
// module id = 337
// module chunks = 0